export enum ImageType {
  PHOTO = 'Photo',
  PLAN = 'Plan',
  INTERIOR = 'Interior',
  DETAIL = 'Detail'
}

export interface ImageTypeOption {
  value: string;
  label: string;
  icon: string;
}

export const IMAGE_TYPE_OPTIONS: ImageTypeOption[] = [
  { value: ImageType.PHOTO, label: 'Photo', icon: 'fa-camera' },
  { value: ImageType.PLAN, label: 'Plan', icon: 'fa-map-location-dot' },
  { value: ImageType.INTERIOR, label: 'Interior', icon: 'fa-house' },
  { value: ImageType.DETAIL, label: 'Detail', icon: 'fa-magnifying-glass' }
];

export const getImageTypeIcon = (imageType: string | undefined): string => {
  const option = IMAGE_TYPE_OPTIONS.find(opt => opt.value === imageType);
  return option?.icon || 'fa-image';
};

export const getImageTypeLabel = (imageType: string | undefined): string => {
  const option = IMAGE_TYPE_OPTIONS.find(opt => opt.value === imageType);
  return option?.label || 'Unknown';
};
